import React from "react";
import GuideModal from "./GuideModal";
import VideoModal from "./VideoModal";
import AvatarAssistant from "./AvatarAssistant";
import GuidedTour from "./GuidedTour";

// Tutto ciò che DF Academy deve montare una sola volta per l'intera app
// (modali, avatar flottante, overlay del tour), separato dai due pulsanti
// dell'header (AcademyLauncher) che vivono in un punto diverso del layout.
export default function AcademyOverlay() {
  return (
    <>
      <GuideModal />
      <VideoModal />
      <AvatarAssistant />
      <GuidedTour />
    </>
  );
}
